<!--  / wrapper \ -->
<section class="wrapper" id="wrapper__section">
    <app-header></app-header> 
    <app-sidebar *ngIf="showSidebar"></app-sidebar>
    <router-outlet></router-outlet>
</section>
<!--  \ wrapper / -->